const CustomArrowIcon = ({
  className = "w-6 h-6", // default 24x24
  fill = "#312F91",
  stroke = "#D7D7D7",
  boxFill = "white",
}) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2453_15784)">
        <path
          d="M20 0.5H4C2.067 0.5 0.5 2.067 0.5 4V20C0.5 21.933 2.067 23.5 4 23.5H20C21.933 23.5 23.5 21.933 23.5 20V4C23.5 2.067 21.933 0.5 20 0.5Z"
          fill={boxFill}
        />
        <path
          d="M20 0.5H4C2.067 0.5 0.5 2.067 0.5 4V20C0.5 21.933 2.067 23.5 4 23.5H20C21.933 23.5 23.5 21.933 23.5 20V4C23.5 2.067 21.933 0.5 20 0.5Z"
          stroke={stroke}
        />
        <path
          d="M7.87831 12.0658L11.8158 8.12831C11.877 8.06706 11.955 8.02534 12.0399 8.00843C12.1248 7.99152 12.2129 8.00018 12.2928 8.03332C12.3728 8.06647 12.4412 8.12259 12.4892 8.1946C12.5373 8.26661 12.5629 8.35127 12.5629 8.43785V11.9379H17.8129C17.9289 11.9379 18.0402 11.9839 18.1222 12.066C18.2043 12.148 18.2504 12.2593 18.2504 12.3754C18.2504 12.4914 18.2043 12.6027 18.1222 12.6847C18.0402 12.7668 17.9289 12.8129 17.8129 12.8129H12.5629V16.3129C12.5629 16.3994 12.5373 16.4841 12.4892 16.5561C12.4412 16.6281 12.3728 16.6842 12.2928 16.7174C12.2129 16.7505 12.1248 16.7592 12.0399 16.7423C11.955 16.7254 11.877 16.6836 11.8158 16.6224L7.87831 12.6849C7.83764 12.6443 7.80537 12.596 7.78335 12.5429C7.76133 12.4898 7.75 12.4328 7.75 12.3754C7.75 12.3179 7.76133 12.2609 7.78335 12.2078C7.80537 12.1547 7.83764 12.1065 7.87831 12.0658Z"
          fill={fill}
        />
        <path
          opacity="0.5"
          d="M6 8.6875L6 16.5625C6 16.8041 6.19588 17 6.4375 17C6.67912 17 6.875 16.8041 6.875 16.5625L6.875 8.6875C6.875 8.44588 6.67912 8.25 6.4375 8.25C6.19588 8.25 6 8.44588 6 8.6875Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2453_15784">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CustomArrowIcon;
